// Place error box below text box, so appearing error does not push text box down
export const jsonInputStyle = {
  container: { display: "flex", flexDirection: "column" },
  body: { order: "1" },
  warningBox: { order: "2" },
};
